import { ModalContent } from '@components/modal';
import { Link } from '@trussworks/react-uswds';

const FeedbackModal = () => {
  return (
    <ModalContent hasCloseButton size='sm' title='Submit Feedback'>
      <div className='padding-4 display-flex flex-column flex-justify-center flex-align-center'>
        <p>To submit feedback or suggestions, send an email to: </p>
        <Link href='mailto:rrs@usace.army.mil?subject=RRS%20Feedback' className='text-bold'>
          rrs@usace.army.mil
        </Link>
      </div>
    </ModalContent>
  );
};

export default FeedbackModal;
